import { environment } from '../../../../enviroments';

import { api } from './axios';
import { createGraphqlClient } from './graphql-client';

const graphqlClient = createGraphqlClient({
  url: environment.url_api_campanha_graphql,
  axiosInstance: api,
});

export const graphql = graphqlClient;
